import { api } from "@/lib/api";

export const PINK = "var(--glow-kids)";
export const KBTN = "min-h-[56px] rounded-2xl px-5 font-display text-base font-extrabold";
const cache = new Map();

// Fetches an authed file (image/audio) once and returns an object URL.
export async function mediaUrl(path) {
  if (!path) return null;
  if (!cache.has(path)) cache.set(path, api.get(path, { responseType: "blob" }).then(({ data }) => URL.createObjectURL(data)).catch((e) => { cache.delete(path); throw e; }));
  return cache.get(path);
}

export const reducedMotion = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

// Soft paper "fwip" made with WebAudio (no file), muted when the person's sounds are off.
export function pageSound(muted) {
  if (muted) return;
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const len = ctx.sampleRate * 0.35;
    const buf = ctx.createBuffer(1, len, ctx.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.sin((Math.PI * i) / len) * 0.25;
    const src = ctx.createBufferSource();
    const f = ctx.createBiquadFilter();
    f.type = "bandpass"; f.frequency.value = 2400; f.Q.value = 0.7;
    src.buffer = buf; src.connect(f); f.connect(ctx.destination); src.start();
    src.onended = () => ctx.close();
  } catch { /* audio not available */ }
}

export async function recordBlob(stream) {
  const type = ["audio/webm;codecs=opus", "audio/mp4", "audio/webm"].find((t) => window.MediaRecorder?.isTypeSupported?.(t)) || "";
  const rec = new MediaRecorder(stream, type ? { mimeType: type } : {});
  const chunks = [];
  rec.ondataavailable = (e) => e.data.size && chunks.push(e.data);
  const done = new Promise((res) => { rec.onstop = () => res(new Blob(chunks, { type: rec.mimeType || "audio/webm" })); });
  rec.start();
  return { stop: () => { rec.stop(); return done; } };
}
